const WSP_CONTEXT_KEY = 'wsp_context';

export const hasWspContextHandoff = (): boolean => {
  try {
    return window.sessionStorage.getItem(WSP_CONTEXT_KEY) !== null;
  } catch {
    // Storage is unavailable, so there is no handoff to read.
    return false;
  }
};

export const removeWspContextHandoff = (): void => {
  try {
    window.sessionStorage.removeItem(WSP_CONTEXT_KEY);
  } catch {
    // Storage is unavailable, so there is no handoff to remove.
  }
};
